import { Injectable, inject } from '@angular/core';
import { HTTP_AP_Affiliate } from '@api-new/companyservice/HTTP_AP_Affiliate';
import { HTTP_AP_Company } from '@api-new/companyservice/HTTP_AP_Company';
import { HTTP_AP_CompanySettings } from '@api-new/companyservice/HTTP_AP_CompanySettings';
import { HTTP_AP_CompanySettingsForCreditReports } from '@api-new/companyservice/HTTP_AP_CompanySettingsForCreditReports';
import { HTTP_AP_CompanySettingsForMortgageCases } from '@api-new/companyservice/HTTP_AP_CompanySettingsForMortgageCases';
import { HTTP_AP_CompanySettingsForMortgageComparisons } from '@api-new/companyservice/HTTP_AP_CompanySettingsForMortgageComparisons';
import { HTTP_AP_CompanySettingsForMortgages } from '@api-new/companyservice/HTTP_AP_CompanySettingsForMortgages';
import { HTTP_AP_CompanySettingsForNotifications } from '@api-new/companyservice/HTTP_AP_CompanySettingsForNotifications';
import { HTTP_AP_CompanySettingsForPreCompletionComparisons } from '@api-new/companyservice/HTTP_AP_CompanySettingsForPreCompletionComparisons';
import { HTTP_AP_CompanySettingsForProperties } from '@api-new/companyservice/HTTP_AP_CompanySettingsForProperties';
import { HTTP_AP_Company_ForDetails } from '@api-new/companyservice/HTTP_AP_Company_ForDetails';
import { HTTP_AP_CreateAffiliate_Request } from '@api-new/companyservice/HTTP_AP_CreateAffiliate_Request';
import { HTTP_AP_CreateCompany_Request } from '@api-new/companyservice/HTTP_AP_CreateCompany_Request';
import { HTTP_AP_CreateNetwork_Request } from '@api-new/companyservice/HTTP_AP_CreateNetwork_Request';
import { HTTP_AP_DeleteCompany_Request } from '@api-new/companyservice/HTTP_AP_DeleteCompany_Request';
import { HTTP_AP_GetAffiliate_Request } from '@api-new/companyservice/HTTP_AP_GetAffiliate_Request';
import { HTTP_AP_GetCompanyAffiliates_Request } from '@api-new/companyservice/HTTP_AP_GetCompanyAffiliates_Request';
import { HTTP_AP_GetCompanyAffiliates_Response } from '@api-new/companyservice/HTTP_AP_GetCompanyAffiliates_Response';
import { HTTP_AP_GetCompanySettingsForCreditReports_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForCreditReports_Request';
import { HTTP_AP_GetCompanySettingsForMortgageCases_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForMortgageCases_Request';
import { HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders_Request';
import { HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders_Response } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders_Response';
import { HTTP_AP_GetCompanySettingsForMortgageComparisons_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForMortgageComparisons_Request';
import { HTTP_AP_GetCompanySettingsForMortgages_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForMortgages_Request';
import { HTTP_AP_GetCompanySettingsForNotifications_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForNotifications_Request';
import { HTTP_AP_GetCompanySettingsForPreCompletionComparisons_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForPreCompletionComparisons_Request';
import { HTTP_AP_GetCompanySettingsForProperties_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettingsForProperties_Request';
import { HTTP_AP_GetCompanySettings_Request } from '@api-new/companyservice/HTTP_AP_GetCompanySettings_Request';
import { HTTP_AP_GetCompany_ForDetails_Request } from '@api-new/companyservice/HTTP_AP_GetCompany_ForDetails_Request';
import { HTTP_AP_GetCompany_Request } from '@api-new/companyservice/HTTP_AP_GetCompany_Request';
import { HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders_Request } from '@api-new/companyservice/HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders_Request';
import { HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders_Response } from '@api-new/companyservice/HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders_Response';
import { HTTP_AP_GetNetworkSettingsForNotifications_Request } from '@api-new/companyservice/HTTP_AP_GetNetworkSettingsForNotifications_Request';
import { HTTP_AP_GetNetwork_Request } from '@api-new/companyservice/HTTP_AP_GetNetwork_Request';
import { HTTP_AP_ListAffiliates_ForSelect_Request } from '@api-new/companyservice/HTTP_AP_ListAffiliates_ForSelect_Request';
import { HTTP_AP_ListAffiliates_ForSelect_Response } from '@api-new/companyservice/HTTP_AP_ListAffiliates_ForSelect_Response';
import { HTTP_AP_ListAffiliates_ForTable_Request } from '@api-new/companyservice/HTTP_AP_ListAffiliates_ForTable_Request';
import { HTTP_AP_ListAffiliates_ForTable_Response } from '@api-new/companyservice/HTTP_AP_ListAffiliates_ForTable_Response';
import { HTTP_AP_ListCompanies_ForSelect_Request } from '@api-new/companyservice/HTTP_AP_ListCompanies_ForSelect_Request';
import { HTTP_AP_ListCompanies_ForSelect_Response } from '@api-new/companyservice/HTTP_AP_ListCompanies_ForSelect_Response';
import { HTTP_AP_ListCompanies_ForTable_Request } from '@api-new/companyservice/HTTP_AP_ListCompanies_ForTable_Request';
import { HTTP_AP_ListCompanies_ForTable_Response } from '@api-new/companyservice/HTTP_AP_ListCompanies_ForTable_Response';
import { HTTP_AP_ListNetworks_ForSelect_Response } from '@api-new/companyservice/HTTP_AP_ListNetworks_ForSelect_Response';
import { HTTP_AP_ListNetworks_ForTable_Request } from '@api-new/companyservice/HTTP_AP_ListNetworks_ForTable_Request';
import { HTTP_AP_ListNetworks_ForTable_Response } from '@api-new/companyservice/HTTP_AP_ListNetworks_ForTable_Response';
import { HTTP_AP_Network } from '@api-new/companyservice/HTTP_AP_Network';
import { HTTP_AP_NetworkSettingsForNotifications } from '@api-new/companyservice/HTTP_AP_NetworkSettingsForNotifications';
import { HTTP_AP_SetCompanySettingsForMortgageComparisonsExcludedLenders_Request } from '@api-new/companyservice/HTTP_AP_SetCompanySettingsForMortgageComparisonsExcludedLenders_Request';
import { HTTP_AP_SetNetworkSettingsForMortgageComparisonsExcludedLenders_Request } from '@api-new/companyservice/HTTP_AP_SetNetworkSettingsForMortgageComparisonsExcludedLenders_Request';
import { HTTP_AP_UpdateAffiliateLogo_Request } from '@api-new/companyservice/HTTP_AP_UpdateAffiliateLogo_Request';
import { HTTP_AP_UpdateAffiliate_Request } from '@api-new/companyservice/HTTP_AP_UpdateAffiliate_Request';
import { HTTP_AP_UpdateCompanyLogo_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanyLogo_Request';
import { HTTP_AP_UpdateCompanyNetwork_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanyNetwork_Request';
import { HTTP_AP_UpdateCompanySettingsForCreditReports_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForCreditReports_Request';
import { HTTP_AP_UpdateCompanySettingsForMortgageCases_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForMortgageCases_Request';
import { HTTP_AP_UpdateCompanySettingsForMortgageComparisons_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForMortgageComparisons_Request';
import { HTTP_AP_UpdateCompanySettingsForMortgages_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForMortgages_Request';
import { HTTP_AP_UpdateCompanySettingsForNotifications_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForNotifications_Request';
import { HTTP_AP_UpdateCompanySettingsForPreCompletionComparisons_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForPreCompletionComparisons_Request';
import { HTTP_AP_UpdateCompanySettingsForProperties_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForProperties_Request';
import { HTTP_AP_UpdateCompanySettingsForProperties_Response } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettingsForProperties_Response';
import { HTTP_AP_UpdateCompanySettings_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompanySettings_Request';
import { HTTP_AP_UpdateCompany_ForDetails_Request } from '@api-new/companyservice/HTTP_AP_UpdateCompany_ForDetails_Request';
import { HTTP_AP_UpdateNetworkLogo_Request } from '@api-new/companyservice/HTTP_AP_UpdateNetworkLogo_Request';
import { HTTP_AP_UpdateNetworkSettingsForNotifications_Request } from '@api-new/companyservice/HTTP_AP_UpdateNetworkSettingsForNotifications_Request';
import { HTTP_AP_UpdateNetwork_Request } from '@api-new/companyservice/HTTP_AP_UpdateNetwork_Request';
import { HTTP_CP_Company } from '@api-new/companyservice/HTTP_CP_Company';
import { HTTP_CP_GetCompany_Request } from '@api-new/companyservice/HTTP_CP_GetCompany_Request';
import { HTTP_CP_LoadSignInBranding_Request } from '@api-new/companyservice/HTTP_CP_LoadSignInBranding_Request';
import { HTTP_CP_LoadSignInBranding_Response } from '@api-new/companyservice/HTTP_CP_LoadSignInBranding_Response';
import { HTTP_CP_LoadSignUpBranding_Request } from '@api-new/companyservice/HTTP_CP_LoadSignUpBranding_Request';
import { HTTP_CP_LoadSignUpBranding_Response } from '@api-new/companyservice/HTTP_CP_LoadSignUpBranding_Response';
import { Observable } from 'rxjs';
import { ApplicationHttpClient, IRequestOptions } from '../../../../../lib/services/application-http.service';

@Injectable({ providedIn: 'root' })
export class CompanyApiService {
  private readonly httpClient = inject(ApplicationHttpClient);

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- GRPC Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // --- HTTP Endpoints - Adviser Portal (ap) ------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_AP_CreateAffiliate(request: HTTP_AP_CreateAffiliate_Request, options?: IRequestOptions): Observable<HTTP_AP_Affiliate> {
    return this.httpClient.post(`/company-service/ap/CreateAffiliate`, request, options);
  }

  HTTP_AP_CreateCompany(request: HTTP_AP_CreateCompany_Request, options?: IRequestOptions): Observable<HTTP_AP_Company> {
    return this.httpClient.post(`/company-service/ap/CreateCompany`, request, options);
  }

  HTTP_AP_CreateNetwork(request: HTTP_AP_CreateNetwork_Request, options?: IRequestOptions): Observable<HTTP_AP_Network> {
    return this.httpClient.post(`/company-service/ap/CreateNetwork`, request, options);
  }

  HTTP_AP_DeleteCompany(request: HTTP_AP_DeleteCompany_Request, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.delete(`/company-service/ap/DeleteCompany`, { params: request });
  }

  HTTP_AP_GetAffiliate(request: HTTP_AP_GetAffiliate_Request, options?: IRequestOptions): Observable<HTTP_AP_Affiliate> {
    return this.httpClient.get(`/company-service/ap/GetAffiliate`, { params: request });
  }

  HTTP_AP_GetCompany(request: HTTP_AP_GetCompany_Request, options?: IRequestOptions): Observable<HTTP_AP_Company> {
    return this.httpClient.get(`/company-service/ap/GetCompany`, { params: request });
  }

  HTTP_AP_GetCompany_ForDetails(
    request: HTTP_AP_GetCompany_ForDetails_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_Company_ForDetails> {
    return this.httpClient.get(`/company-service/ap/GetCompany_ForDetails`, { params: request });
  }

  // FIXME #5860 Incorrect endpoint name -- has `Get` verb in its name, which implies one result, but is returning a list, which means it should have the `List` verb instead
  HTTP_AP_GetCompanyAffiliates(
    request: HTTP_AP_GetCompanyAffiliates_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetCompanyAffiliates_Response> {
    return this.httpClient.get(`/company-service/ap/GetCompanyAffiliates`, { params: request });
  }

  HTTP_AP_GetCompanySettings(request: HTTP_AP_GetCompanySettings_Request, options?: IRequestOptions): Observable<HTTP_AP_CompanySettings> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettings`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForCreditReports(
    request: HTTP_AP_GetCompanySettingsForCreditReports_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForCreditReports> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForCreditReports`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForMortgageCases(
    request: HTTP_AP_GetCompanySettingsForMortgageCases_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForMortgageCases> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForMortgageCases`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForMortgageComparisons(
    request: HTTP_AP_GetCompanySettingsForMortgageComparisons_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForMortgageComparisons> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForMortgageComparisons`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders(
    request: HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetCompanySettingsForMortgageComparisons_ForLenders_Response> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForMortgageComparisons_ForLenders`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForMortgages(
    request: HTTP_AP_GetCompanySettingsForMortgages_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForMortgages> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForMortgages`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForNotifications(
    request: HTTP_AP_GetCompanySettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForNotifications> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForNotifications`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForPreCompletionComparisons(
    request: HTTP_AP_GetCompanySettingsForPreCompletionComparisons_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForPreCompletionComparisons> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForPreCompletionComparisons`, { params: request });
  }

  HTTP_AP_GetCompanySettingsForProperties(
    request: HTTP_AP_GetCompanySettingsForProperties_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForProperties> {
    return this.httpClient.get(`/company-service/ap/GetCompanySettingsForProperties`, { params: request });
  }

  HTTP_AP_GetNetwork(request: HTTP_AP_GetNetwork_Request, options?: IRequestOptions): Observable<HTTP_AP_Network> {
    return this.httpClient.get(`/company-service/ap/GetNetwork`, { params: request });
  }

  HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders(
    request: HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_GetNetworkSettingsForMortgageComparisons_ForLenders_Response> {
    return this.httpClient.get(`/company-service/ap/GetNetworkSettingsForMortgageComparisons_ForLenders`, { params: request });
  }

  HTTP_AP_GetNetworkSettingsForNotifications(
    request: HTTP_AP_GetNetworkSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_NetworkSettingsForNotifications> {
    return this.httpClient.get(`/company-service/ap/GetNetworkSettingsForNotifications`, { params: request });
  }

  HTTP_AP_ListAffiliates_ForSelect(
    request: HTTP_AP_ListAffiliates_ForSelect_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListAffiliates_ForSelect_Response> {
    return this.httpClient.get(`/company-service/ap/ListAffiliates_ForSelect`, { params: request });
  }

  HTTP_AP_ListAffiliates_ForTable(
    request: HTTP_AP_ListAffiliates_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListAffiliates_ForTable_Response> {
    return this.httpClient.get(`/company-service/ap/ListAffiliates_ForTable`, { params: request });
  }

  HTTP_AP_ListCompanies_ForSelect(
    request: HTTP_AP_ListCompanies_ForSelect_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCompanies_ForSelect_Response> {
    return this.httpClient.get(`/company-service/ap/ListCompanies_ForSelect`, { params: request });
  }

  HTTP_AP_ListCompanies_ForTable(
    request: HTTP_AP_ListCompanies_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListCompanies_ForTable_Response> {
    return this.httpClient.get(`/company-service/ap/ListCompanies_ForTable`, { params: request });
  }

  HTTP_AP_ListNetworks_ForSelect(request?: undefined, options?: IRequestOptions): Observable<HTTP_AP_ListNetworks_ForSelect_Response> {
    return this.httpClient.get(`/company-service/ap/ListNetworks_ForSelect`, { params: request });
  }

  HTTP_AP_ListNetworks_ForTable(
    request: HTTP_AP_ListNetworks_ForTable_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_ListNetworks_ForTable_Response> {
    return this.httpClient.get(`/company-service/ap/ListNetworks_ForTable`, { params: request });
  }

  HTTP_AP_SetCompanySettingsForMortgageComparisonsExcludedLenders(
    request: HTTP_AP_SetCompanySettingsForMortgageComparisonsExcludedLenders_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.put(`/company-service/ap/SetCompanySettingsForMortgageComparisonsExcludedLenders`, request, options);
  }

  HTTP_AP_SetNetworkSettingsForMortgageComparisonsExcludedLenders(
    request: HTTP_AP_SetNetworkSettingsForMortgageComparisonsExcludedLenders_Request,
    options?: IRequestOptions,
  ): Observable<undefined> {
    return this.httpClient.put(`/company-service/ap/SetNetworkSettingsForMortgageComparisonsExcludedLenders`, request, options);
  }

  HTTP_AP_UpdateAffiliate(request: HTTP_AP_UpdateAffiliate_Request, options?: IRequestOptions): Observable<HTTP_AP_Affiliate> {
    return this.httpClient.put(`/company-service/ap/UpdateAffiliate`, request, options);
  }

  HTTP_AP_UpdateAffiliateLogo(request: HTTP_AP_UpdateAffiliateLogo_Request, options?: IRequestOptions): Observable<HTTP_AP_Affiliate> {
    return this.httpClient.patch(`/company-service/ap/UpdateAffiliateLogo`, request, options);
  }

  HTTP_AP_UpdateCompany_ForDetails(
    request: HTTP_AP_UpdateCompany_ForDetails_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_Company_ForDetails> {
    return this.httpClient.put(`/company-service/ap/UpdateCompany_ForDetails`, request, options);
  }

  HTTP_AP_UpdateCompanyLogo(request: HTTP_AP_UpdateCompanyLogo_Request, options?: IRequestOptions): Observable<HTTP_AP_Company> {
    return this.httpClient.patch(`/company-service/ap/UpdateCompanyLogo`, request, options);
  }

  HTTP_AP_UpdateCompanyNetwork(request: HTTP_AP_UpdateCompanyNetwork_Request, options?: IRequestOptions): Observable<HTTP_AP_Company> {
    return this.httpClient.patch(`/company-service/ap/UpdateCompanyNetwork`, request, options);
  }

  HTTP_AP_UpdateCompanySettings(
    request: HTTP_AP_UpdateCompanySettings_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettings> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettings`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForCreditReports(
    request: HTTP_AP_UpdateCompanySettingsForCreditReports_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForCreditReports> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForCreditReports`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForMortgageCases(
    request: HTTP_AP_UpdateCompanySettingsForMortgageCases_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForMortgageCases> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForMortgageCases`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForMortgageComparisons(
    request: HTTP_AP_UpdateCompanySettingsForMortgageComparisons_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForMortgageComparisons> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForMortgageComparisons`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForMortgages(
    request: HTTP_AP_UpdateCompanySettingsForMortgages_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForMortgages> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForMortgages`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForNotifications(
    request: HTTP_AP_UpdateCompanySettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForNotifications> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForNotifications`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForPreCompletionComparisons(
    request: HTTP_AP_UpdateCompanySettingsForPreCompletionComparisons_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_CompanySettingsForPreCompletionComparisons> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForPreCompletionComparisons`, request, options);
  }

  HTTP_AP_UpdateCompanySettingsForProperties(
    request: HTTP_AP_UpdateCompanySettingsForProperties_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_UpdateCompanySettingsForProperties_Response> {
    return this.httpClient.put(`/company-service/ap/UpdateCompanySettingsForProperties`, request, options);
  }

  HTTP_AP_UpdateNetwork(request: HTTP_AP_UpdateNetwork_Request, options?: IRequestOptions): Observable<HTTP_AP_Network> {
    return this.httpClient.put(`/company-service/ap/UpdateNetwork`, request, options);
  }

  HTTP_AP_UpdateNetworkLogo(request: HTTP_AP_UpdateNetworkLogo_Request, options?: IRequestOptions): Observable<HTTP_AP_Network> {
    return this.httpClient.put(`/company-service/ap/UpdateNetworkLogo`, request, options);
  }

  HTTP_AP_UpdateNetworkSettingsForNotifications(
    request: HTTP_AP_UpdateNetworkSettingsForNotifications_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_AP_NetworkSettingsForNotifications> {
    return this.httpClient.put(`/company-service/ap/UpdateNetworkSettingsForNotifications`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Client Portal (cp) -------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  HTTP_CP_GetCompany(request: HTTP_CP_GetCompany_Request, options?: IRequestOptions): Observable<HTTP_CP_Company> {
    return this.httpClient.get(`/company-service/cp/GetCompany`, { params: request });
  }

  HTTP_CP_LoadSignInBranding(
    request: HTTP_CP_LoadSignInBranding_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_LoadSignInBranding_Response> {
    return this.httpClient.post(`/company-service/cp/LoadSignInBranding`, request, options);
  }

  HTTP_CP_LoadSignUpBranding(
    request: HTTP_CP_LoadSignUpBranding_Request,
    options?: IRequestOptions,
  ): Observable<HTTP_CP_LoadSignUpBranding_Response> {
    return this.httpClient.post(`/company-service/cp/LoadSignUpBranding`, request, options);
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- HTTP Endpoints - Extended (x) -------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // Empty

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- INIT Endpoints ----------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- PUBLIC Endpoints --------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  PUBLIC_UptimeCheck(request?: undefined, options?: IRequestOptions): Observable<undefined> {
    return this.httpClient.get(`/company-service/.public/UptimeCheck`, { params: request });
  }

  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //
  // --- SPECIAL Endpoints -------------------------------------------------------------------------------------------------------------------------------- //
  // ------------------------------------------------------------------------------------------------------------------------------------------------------ //

  // TODO #6091 Delete this after the CompanyCreditReportSettings -> CompanySettingsForCreditReports migration is complete

  // TODO #6091 Delete this after the CompanyMortgageComparisonSettings -> CompanySettingsForMortgageComparisons migration is complete

  // TODO #6091 Delete this after the CompanyMortgageSettings -> CompanySettingsForMortgages migration is complete

  // TODO #6091 Delete this after the CompanyNotificationSettings -> CompanySettingsForNotifications migration is complete

  // TODO #6091 Delete this after the CompanyPropertySettings -> CompanySettingsForProperties migration is complete

  // TODO #6091 Delete this after the NetworkMortgageComparisonSettings -> NetworkSettingsForMortgageComparisons migration is complete

  // TODO #6091 Delete this after the NetworkNotificationSettings -> NetworkSettingsForNotifications migration is complete
}
